import React from "react";
import {Checkbox, Grid, Hidden, Typography} from "@material-ui/core";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { NotificationManager } from "react-notifications";
import style from "./style";
import CREATE_CHEF_PAYOUT from "../../graphql/mutations/chef/create_chef_payout";
import { Mutation } from "react-apollo";
import InputField from "../../components/Field";
import Fab from "@material-ui/core/Fab/Fab";
import DinerButton from '../../components/DinerButton';
import moment from 'moment'
import axios from 'axios';
import {webFont} from "../../config/theme";
import { DOCUMENT_UPLOAD } from '../../config/constants';

const PayoutSchema = Yup.object().shape({
  bankName: Yup.string().required("Bank name is required"),
  routingNumber: Yup.string()
    .matches(/^[0-9]*$/, {
      message: "Incorrect format. Input only numbers.",
      excludeEmptyString: true
    })
    .length(9, "Please enter valid routing number (9 digits)")
    .required("Routing number is required"),
  accountNumber: Yup.string()
    .matches(/^[0-9]*$/, {
      message: "Incorrect format. Input only numbers.",
      excludeEmptyString: true
    })
    .min(6, "Please enter a valid account number (6 to 17 digit)")
    .max(17, "Please enter a valid account number (6 to 17 digit)")
    .required("Account number is required"),
  confirmAccount: Yup.string()
    .oneOf([Yup.ref('accountNumber'), null], 'Account number does not matches')
    .required('This is required and should match'),
  dob: Yup.string()
    .nullable()
    .required("Date of birth is required"),
  ssn: Yup.string()
    .length(11, "Please enter valid ssn number (max 9 numbers)")
    .required("SSN is required"),
  mobile: Yup.string()
    .matches(/^[0-9]*$/, {
      message: "Incorrect format. Input only numbers ",
      excludeEmptyString: true
    })
    .nullable()
    .length(10, "Please enter a valid number (10 digits)")
    .required("Phone number is required")
});
const uploadErrMsg = "You can only upload images(JPG / PNG) or PDF files upto 10MB in size";

class PayoutInfo extends React.Component {
  constructor(props) {
    super(props);
    const chefDetails = props.details && props.details.chef ? props.details.chef : null;

    this.state = {
      askCellPhone: false,
      cellPhone: '',
      uploadDocument: false,
      frontUploaded: chefDetails && !!chefDetails.identityDocuments && !!chefDetails.identityDocuments.front,
      backUploaded: chefDetails && !!chefDetails.identityDocuments && !!chefDetails.identityDocuments.back,
      date:
        (props.details &&
          props.details.chef &&
          props.details.chef.dateOfBirth) ?
        moment(props.details.chef.dateOfBirth).format("MM/DD/YYYY") :
        moment("01/01/1970").format("MM/DD/YYYY"),
      initialValues: {
        bankName: "",
        routingNumber: "",
        accountNumber: "",
        confirmAccount: "",
        dob: (props.details.chef && props.details.chef.dateOfBirth) ?
          moment(props.details.chef.dateOfBirth).format('MM/DD/YYYY') :
          moment("01/01/1970").format("MM/DD/YYYY"),
        ssn: "",
        stripeRecipientAgreementAccepted: chefDetails && chefDetails.stripeRecipientAgreementAccepted || false
      }
    };

    this.handleDocumentUpload = this.handleDocumentUpload.bind(this);
  }

  componentDidMount() {
    window.onload = function() {
      window.scrollTo(0, 0);
    };

    const { payout, details } = this.props;
    let initialValues = {
      bankName: payout.bankName || "",
      routingNumber: payout.routingNumber || "",
      accountNumber: payout.accountNumber || "",
      confirmAccount: payout.confirmAccount || "",
      dob: moment(this.state.date).format("MM/DD/YYYY"),
      ssn: payout.ssn || ""
    };

    this.setState({ initialValues });
    if (!!this.props.details.chef && !!this.props.details.chef.dateOfBirth) {
      const updatedDate = moment(this.props.details.chef.dateOfBirth).format("MM/DD/YYYY");
      this.setState({ date: updatedDate });
    }

    if (!!this.props.details.chef && !!this.props.details.chef.identityDocuments) {
      const frontUploaded = this.props.details.chef.identityDocuments.front || false;
      const backUploaded = this.props.details.chef.identityDocuments.back || false;
      this.setState({ frontUploaded, backUploaded });
    }

    if (details && details.chef) {
      if (details.chef.cellPhone) {
        this.setState({ askCellPhone: false, cellPhone: details.chef.cellPhone });
      } else {
        this.setState({ askCellPhone: true, cellPhone: null });
      }
      if (details && details.chef) {
        if (details.chef.stripeRecipientAgreementAccepted) { this.setState({ stripeRecipientAgreementAccepted: details.chef.stripeRecipientAgreementAccepted }); }
      }
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props) {
      if (props.details) {
        if (props.details.chef) {
          if (props.details.chef.identityDocuments) {
            const updated = {};
            if (props.details.chef.identityDocuments.front) {
              updated.front = props.details.chef.identityDocuments.front;
            }

            if (props.details.chef.identityDocuments.back) {
              updated.back = props.details.chef.identityDocuments.back;
            }

            if (props.details.chef.stripeRecipientAgreementAccepted) {
              updated.stripeRecipientAgreementAccepted = props.details.chef.stripeRecipientAgreementAccepted;
            }
            return updated;
          }
        }
      }
    }
  }

  handleDocumentUpload(files, type) {
    this.setState({ uploadDocument: true });

    const frontDocInput = document.getElementById('frontDocument');
    const backDocInput = document.getElementById('backDocument');

    if (!files.length) {
      this.setState({ uploadDocument: false });
      return;
    }
    const doc = files[0];
    const fileType = doc.type;
    const size = doc.size;
    const allowedType = [
      'image/png',
      'image/jpeg',
      'application/pdf',
      'image/jpg'
    ];

    const mimeIndex = allowedType.findIndex(item => item === fileType);

    if (mimeIndex < 0) {
      this.setState({ uploadDocument: false });
      frontDocInput.value = '';
      backDocInput.value = '';
      NotificationManager.error(uploadErrMsg, "Document upload", 4000);
      return;
    }

    if (size > 10485760) {
      this.setState({ uploadDocument: false });
      frontDocInput.value = '';
      backDocInput.value = '';
      NotificationManager.error(uploadErrMsg, "Document upload", 4000);
      return;
    }

    NotificationManager.info('Please do not close or navigate away from this page until upload finishes', 'Document upload', 4000);

    let formData = new FormData();
    const token = window.localStorage.getItem("ccZestyAuthToken");
    const userId = window.localStorage.getItem("zg-cc-auth-userId");

    formData.append("doc", doc);
    formData.append("documentType", type);
    formData.append("userId", userId);

    axios
      .post(DOCUMENT_UPLOAD, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        }
      })
      .then(response => {
        const updateState = {
          uploadDocument: false,
        };

        if (type === 'front') {
          updateState.frontUploaded = true;
        }

        if (type === 'back') {
          updateState.backUploaded = true;
        }
        this.setState(updateState);
        frontDocInput.value = '';
        backDocInput.value = '';
        NotificationManager.info(`Identity document ${type} uploaded successfully`, 'Document upload')
      })
      .catch(err => {
        this.setState({ uploadDocument: false });
        frontDocInput.value = '';
        backDocInput.value = '';
        NotificationManager.error('There was an error uploading document. Please try again later.', 'Document upload');
      });
  }

  render() {
    const { payout, onSubmit, details, values } = this.props;
    let { initialValues } = this.state;
    const isExists = payout && payout.routingNumber;
    return (
      <div className="chef-right-col">

        <div className="schedule-head-col">
          <div className="header-step-col">
            <p className="located-text" style={style.headerText}>
              Payout info.
            </p>
            <div className="cont-btn">
              <DinerButton />
              {(!this.props.loading && !this.state.uploadDocument) && (
                <Fab
                  data-test-id={"skip-id"}
                  variant={"extended"}
                  id={"payout-submit-skip"}
                  type="submit"
                  style={style.skipButtonPayout}
                  onClick={() => {
                    document.getElementById('payout-submit-skip').disabled=true;
                    this.props.skip();
                  }}
                >
                  Do this later
                </Fab>
              )}
            </div>
          </div>
          <Typography variant={'h4'} style={{ marginTop: 30 }}>Personal identity details</Typography>
          <Typography variant={'h5'} style={{ marginTop: 30 }}>Upload identity document*</Typography>
          <Typography variant={'h6'} style={{ fontSize: 15, fontWeight: 300 }}>This could be your passport or any valid US identity card. Please complete  uploading the front image of your identity document, before inputing the rest of the identity and payout information.</Typography>
          <Grid container justify={"space-between"} style={{ marginTop: 30 }}>
            <Grid item xs={12} sm={6} style={{ marginTop: 10 }}>
              <input
                disabled={this.state.uploadDocument}
                type="file"
                accept="image/png, image/jpeg, application/pdf"
                name="frontDocument"
                id="frontDocument"
                style={{ display: "none" }}
                onChange={data => this.handleDocumentUpload(data.target.files, 'front')} />

              {this.state.frontUploaded ? (
                <React.Fragment>
                <Hidden mdDown>
                  <Fab
                    data-test-id={"frontDocUpload"}
                    variant={"extended"}
                    disabled={this.props.loading || this.state.uploadDocument}
                    type="button"
                    style={
                      this.props.loading || this.state.uploadDocument
                        ? style.submitButtonDisabled
                        : style.submitButton
                    }
                    onClick={() => document.getElementById('frontDocument').click()}
                  >
                    Update front image
                  </Fab>
                </Hidden>
                  <Hidden lgUp>
                    <Fab
                      data-test-id={"frontDocUpload"}
                      variant={"extended"}
                      disabled={this.props.loading || this.state.uploadDocument}
                      type="button"
                      style={
                        this.props.loading || this.state.uploadDocument
                          ? style.submitButtonDisablediPad
                          : style.submitButtoniPad
                      }
                      onClick={() => document.getElementById('frontDocument').click()}
                    >
                      Update front image
                    </Fab>
                  </Hidden>
                </React.Fragment>) : (
                  <React.Fragment>

                    <Hidden mdDown>
                      <Fab
                        data-test-id={"frontDocUpload"}
                        variant={"extended"}
                        disabled={this.props.loading || this.state.uploadDocument || this.state.frontUploaded}
                        type="button"
                        style={
                          this.props.loading || this.state.uploadDocument || this.state.frontUploaded
                            ? style.submitButtonDisabled
                            : style.submitButton
                        }
                        onClick={() => document.getElementById('frontDocument').click()}
                      >
                        Upload front image
                      </Fab>
                    </Hidden>
                      <Hidden lgUp>
                        <Fab
                          data-test-id={"frontDocUpload"}
                          variant={"extended"}
                          disabled={this.props.loading || this.state.uploadDocument || this.state.frontUploaded}
                          type="button"
                          style={
                            this.props.loading || this.state.uploadDocument || this.state.frontUploaded
                              ? style.submitButtonDisablediPad
                              : style.submitButtoniPad
                          }
                          onClick={() => document.getElementById('frontDocument').click()}
                        >
                          Upload front image
                        </Fab>
                      </Hidden>

                  </React.Fragment>
              )}
            </Grid>
            <Grid item xs={12} sm={6} style={{ marginTop: 10 }}>
              <input
                disabled={this.state.uploadDocument}
                type="file"
                accept="image/png, image/jpeg, application/pdf"
                name="backDocument"
                id="backDocument"
                style={{ display: "none" }}
                onChange={data => this.handleDocumentUpload(data.target.files, 'back')} />

              { this.state.backUploaded ? (
                <React.Fragment>
                <Hidden mdDown>
                  <Fab
                    data-test-id={"backDocUpload"}
                    variant={"extended"}
                    disabled={this.props.loading || this.state.uploadDocument}
                    type="button"
                    style={
                      this.props.loading || this.state.uploadDocument
                        ? style.submitButtonDisabled
                        : style.submitButton
                    }
                    onClick={() => document.getElementById('backDocument').click()}
                  >
                    Update back image
                  </Fab>
                </Hidden>
                  <Hidden lgUp>
                    <Fab
                      data-test-id={"backDocUpload"}
                      variant={"extended"}
                      disabled={this.props.loading || this.state.uploadDocument}
                      type="button"
                      style={
                        this.props.loading || this.state.uploadDocument
                          ? style.submitButtonDisablediPad
                          : style.submitButtoniPad
                      }
                      onClick={() => document.getElementById('backDocument').click()}
                    >
                      Update back image
                    </Fab>
                  </Hidden>
                </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <div className="payout-back-optional">
                        <span className="optional-message">(Optional)</span>
                    <Hidden mdDown>
                      <Fab
                        data-test-id={"backDocUpload"}
                        variant={"extended"}
                        disabled={this.props.loading || this.state.uploadDocument || this.state.backUploaded}
                        type="button"
                        style={
                          this.props.loading || this.state.uploadDocument || this.state.backUploaded
                            ? style.submitButtonDisabled
                            : style.submitButton
                        }
                        onClick={() => document.getElementById('backDocument').click()}
                      >
                        Upload back image
                      </Fab>
                    </Hidden>
                      <Hidden lgUp>
                        <Fab
                          data-test-id={"backDocUpload"}
                          variant={"extended"}
                          disabled={this.props.loading || this.state.uploadDocument || this.state.backUploaded}
                          type="button"
                          style={
                            this.props.loading || this.state.uploadDocument || this.state.backUploaded
                              ? style.submitButtonDisablediPad
                              : style.submitButtoniPad
                          }
                          onClick={() => document.getElementById('backDocument').click()}
                        >
                          Upload back image
                        </Fab>
                      </Hidden>
                      </div>
                    </React.Fragment>
                      ) }
            </Grid>
          </Grid>
        </div>
        <Mutation mutation={CREATE_CHEF_PAYOUT}>
          {updatePayout => (
            <Formik
              initialValues={{ ...initialValues, ...{ dob: this.state.date, mobile: this.state.cellPhone } }}
              validationSchema={PayoutSchema}
              enableReinitialize
              onSubmit={values => {
                if (!this.state.stripeRecipientAgreementAccepted) return;
                document.getElementById('payout-submit').disabled = true;
                onSubmit(updatePayout, {
                  ...values,
                  dob: values.dob,
                  stripeRecipientAgreementAccepted: this.state.stripeRecipientAgreementAccepted
                })
              }}
            >
              {({ errors, touched, values }) => (
                <Form>
                  <Grid container>
                    <Grid container direction={'row'} spacing={4}>
                      <Grid item lg={6} xs={12}>
                        <InputField
                          name={"dob"}
                          placeholder={"MM/DD/YYYY"}
                          error={errors.dob && touched.dob}
                          errorMessage={errors.dob}
                          label={"DATE OF BIRTH"}
                          style={{width:'100%'}}
                          type={"text"}
                          masked={true}
                          mask={"99/99/9999"}
                          value={moment(this.state.date).format("MM/DD/YYYY") || moment("01/01/1970").format("MM/DD/YYYY")}
                        />
                      </Grid>
                      <Grid item lg={6} xs={12}>
                        <InputField
                          name={"ssn"}
                          placeholder={"000-00-0000"}
                          error={errors.ssn && touched.ssn}
                          errorMessage={errors.ssn}
                          label={"SOCIAL SECURITY NUMBER"}
                          type={"text"}
                          masked={true}
                          mask={"999-99-9999"}
                        />
                      </Grid>
                      {this.state.askCellPhone && <Grid item lg={6} xs={12}>
                        <InputField
                          name={"mobile"}
                          placeholder={"Enter phone number (10 Digits)"}
                          error={errors.mobile && touched.mobile}
                          errorMessage={errors.mobile}
                          label={"CELL PHONE"}
                          type={"text"}
                          masked={true}
                          mask={"9999999999"}
                        />
                      </Grid>}
                    </Grid>

                    <Grid container direction={'row'} spacing={4}>
                      <Typography variant={'h4'} style={{ marginTop: 60, marginBottom: 15, marginLeft: 10, fontFamily: webFont }}>Banking details</Typography>
                    </Grid>
                    <Grid container direction={'row'} spacing={4}>
                    <Grid item lg={6} xs={12}>
                      <InputField
                        name={"bankName"}
                        placeholder={"Enter Bank Name"}
                        error={errors.bankName && touched.bankName}
                        errorMessage={errors.bankName}
                        label={"BANK NAME"}
                        type={"text"}
                      />
                    </Grid>
                    <Grid item lg={6} xs={12} >
                      <InputField
                        name={"routingNumber"}
                        placeholder={"Enter Routing Number"}
                        error={errors.routingNumber && touched.routingNumber}
                        errorMessage={errors.routingNumber}
                        label={"ROUTING NUMBER"}
                        type={"text"}
                      />
                    </Grid>
                    </Grid>

                    <Grid container direction={'row'} spacing={4}>
                    <Grid item lg={6} xs={12}>
                      <InputField
                        name={"accountNumber"}
                        placeholder={"Account Number"}
                        error={errors.accountNumber && touched.accountNumber}
                        errorMessage={errors.accountNumber}
                        label={"CHECKING ACCOUNT NUMBER"}
                        type={"text"}
                      />
                    </Grid>
                    <Grid item lg={6} xs={12}>
                      <InputField
                        name={"confirmAccount"}
                        placeholder={"Confirm Account Number"}
                        error={errors.confirmAccount && touched.confirmAccount}
                        errorMessage={"Account number does not matches"}
                        label={"CONFIRM ACCOUNT"}
                        type={"text"}
                      />
                    </Grid>
                    </Grid>

                    <Grid item md={12} sm={12}>
                      <div className="payout-checkbox-stripe-terms">
                        <Checkbox checked={this.state.stripeRecipientAgreementAccepted} onChange={() => this.setState({ stripeRecipientAgreementAccepted: !this.state.stripeRecipientAgreementAccepted })} />
                        <p>I agree to our Services Agreement and the <a href="https://stripe.com/in/connect-account/legal/recipient" target="_blank">Stripe Recipient Agreement</a>.</p>
                      </div>
                    </Grid>

                    <Grid item md={12} sm={12} className="verify-chef-btn">
                      {!this.props.loading && <Fab
                          data-test-id={"payoutsub"}
                          variant={"extended"}
                          id={"payout-submit"}
                          disabled={this.props.loading || this.state.uploadDocument || !this.state.frontUploaded || !this.state.stripeRecipientAgreementAccepted}
                          type="submit"
                          style={
                            this.props.loading || this.state.uploadDocument || !this.state.frontUploaded || !this.state.stripeRecipientAgreementAccepted
                                ? style.submitButtonDisabled
                                : style.submitButton
                          }
                      >
                        Create my portfolio
                      </Fab>}
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          )}
        </Mutation>
      </div>
    );
  }
}

export default PayoutInfo;
